<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="applyFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="search">
                <a-select
                  slot="addonAfter"
                  default-value="batch_number"
                  style="width: 90px"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                >
                  <a-select-option value="batch_number">
                    Batch #
                  </a-select-option>
                  <a-select-option value="site"> Site </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
          <hr />
        </form>
        <form role="form" @submit.prevent>
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row">
            <div class="col">
              <a-select
                v-model="table.filters.status"
                mode="multiple"
                @change="setFilter"
                show-search
                optionFilterProp="children"
              >
                <a-select-option value="For Receive"
                  >For Receive</a-select-option
                >
                <a-select-option value="Posted"
                  >Posted (Received)</a-select-option
                >
              </a-select>

              <!-- <a-radio-group
                v-model="table.filters.status"
                :default-value="null"
                @change="setFilter"
              >
                <a-radio :style="radio.style" value="For Receive">
                  For Receive
                </a-radio>
                <a-radio :style="radio.style" value="Posted">
                  Posted (Received)
                </a-radio>
              </a-radio-group> -->
            </div>
          </div>

          <hr />
          <h6 class="heading-small text-muted mb-4">
            Filter by Membership Program
          </h6>
          <div class="row">
            <div class="col">
              <a-select
                v-model="table.filters.membership_program_id"
                @change="setFilter"
                show-search
                optionFilterProp="children"
              >
                <a-select-option :value="null">All</a-select-option>
                <a-select-option
                  v-for="membershipProgram in options.membershipPrograms"
                  v-bind:value="membershipProgram.id"
                  v-bind:key="membershipProgram.id"
                >
                  {{ membershipProgram.name }}
                </a-select-option>
              </a-select>
              <!-- <a-radio-group
                  v-model="table.filters.membership_program_id"
                  :default-value="null"
                  @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null">
                  All
                </a-radio>
                <a-radio
                    :style="radio.style"
                    v-for="membershipProgram in options.membershipPrograms"
                    :key="membershipProgram.id"
                    :value="membershipProgram.id"
                >
                  <a-tooltip>
                    <template #title>{{ membershipProgram.name  }}</template>
                    {{ membershipProgram.name | truncate(20, '...') }}
                  </a-tooltip>
                </a-radio>
              </a-radio-group> -->
            </div>
          </div>

          <hr />
          <h6 class="heading-small text-muted mb-4">Filter by Card Types</h6>
          <div class="row">
            <div class="col">
              <a-select
                v-model="table.filters.card_type_id"
                @change="setFilter"
                mode="multiple"
                show-search
                optionFilterProp="children"
              >
                <a-select-option
                  v-for="cardType in options.cardTypes"
                  v-bind:value="cardType.id"
                  v-bind:key="cardType.id"
                >
                  {{ cardType.name }}
                </a-select-option>
              </a-select>

              <!-- <a-radio-group
                  v-model="table.filters.card_type_id"
                  :default-value="null"
                  @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null">
                  All
                </a-radio>
                <a-radio
                    :style="radio.style"
                    v-for="cardType in options.cardTypes"
                    :key="cardType.id"
                    :value="cardType.id"
                >
                  {{ cardType.name }}
                </a-radio>
              </a-radio-group> -->
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
        >
          <!-- <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              >+ Add Card Order</base-button
            >
          </template> -->

          <template #formDrawer>
            <a-drawer
              :key="keyCheck"
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <!-- <CardReceiveForm
                :viewMode="viewMode"
                :cardReceiveData="cardReceiveData"
                @closeDrawer="closeDrawer"
              /> -->
              <CardReceiveOptionForm
                :viewMode="viewMode"
                :cardReceiveData="cardReceiveData"
                @closeOptionDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              v-if="
                selectedActions.includes('Receive') &&
                tableProps.rowData.cardOrderStatus.name != 'Posted'
              "
              class="btn btn-warning btn-sm w-100"
              style="background-color: rgb(255, 157, 92) !important"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Receive
            </button>
            <button
              id="view"
              v-if="
                selectedActions.includes('Receive') &&
                tableProps.rowData.cardOrderStatus.name == 'Posted'
              "
              class="btn btn-success btn-sm w-100"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>
            <!-- <button
              id="edit"
              class="btn btn-warning btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button> -->
            <!-- <a-popconfirm
              title="You are about to receive this cards?"
              @confirm="receiveRow(tableProps.rowData)"
              okText="Receive"
              cancelText="Cancel"
            >
              <a class="btn btn-success btn-sm text-white">Receive</a>
            </a-popconfirm> -->
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
// import CardReceiveForm from './CardReceiveForm.vue';
import CardReceiveOptionForm from './CardReceiveOptionForm.vue';
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    // CardReceiveForm
    CardReceiveOptionForm
  },
  data() {
    return {
      keyCheck: 1,
      gradientType: 'gradient-teal',
      // selectedActions: [],
      cardReceiveData: null,
      searchType: 'batch_number',
      search: null,
      drawer: {
        visible: false,
        width: 1200,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Card Receive',
        apiUrl:
          '/api/v1/clp_card_orders?&origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [
          'actions',
          { name: 'batch_number', title: 'Batch Number' },
          { name: 'cardOrderStatus.name', title: 'Status' },
          { name: 'site.name', title: 'Site' },
          { name: 'membershipProgram.name', title: 'Membership Program' },
          { name: 'cardType.name', title: 'Card Type' },
          { name: 'card_number_from', title: 'Serial # From' },
          { name: 'card_number_to', title: 'Serial # To' }
        ],
        filters: {
          status: [],
          status_code: null,
          name: null,
          batch_number: null,
          site: null,
          membership_program_id: null,
          card_type_id: []
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      },

      options: {
        cardStatuses: [],
        membershipPrograms: [],
        cardTypes: []
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    async openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.cardReceiveData = rowData;

      //Call endpoint for card details and summary
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_card_orders/' +
          this.cardReceiveData.batch_number +
          '/card_details'
      );
      this.cardReceiveData.fullCardDetails = response;
      this.keyCheck++;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.cardReceiveData = null;
    },

    applyFilter() {
      if (
        this.table.filters['membership_program_id'] == null &&
        this.table.filters['status'] &&
        this.table.filters['card_type_id'] &&
        this.table.filters['card_type_id'].length == 0 &&
        this.table.filters['status'].length == 0 &&
        this.table.filters['batch_number'] == null &&
        this.table.filters['site'] == null &&
        this.table.filters['status_code'] == null &&
        this.table.filters['name'] == null
      ) {
        this.table.filters.hasFilter = false;
      } else {
        this.table.filters.hasFilter = true;
      }
      this.setFilter();
    },
    setFilter() {
      this.$root.$emit('refreshTable');
    },
    searchTypeOnChange() {
      this.table.filters = {
        batch_number: null,
        site: null
      };
      this.table.filters[this.searchType] = this.search;
    },
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.options.membershipPrograms = response.data;
    },
    async getCardTypes(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/card_types`
      );
      this.options.cardTypes = data;
    }
  },
  watch: {
    search(val) {
      if (val == '') {
        this.search = null;
      } else {
        this.table.filters.hasFilter = true;
      }
      this.table.filters[this.searchType] = val;
    },
    'table.filters.membership_program_id': function (val) {
      if (val == null) {
        this.options.cardTypes = [];
      } else {
        this.getCardTypes(val);
      }
    }
  },
  created() {
    this.$store.dispatch('setCurrentModule', 'CardReceive');
    this.getMembershipPrograms();
  },

  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  }
};
</script>

<style scoped></style>
